import moment from 'moment'

export const formatDate = date => moment(date).format('dddd l')



// WEBPACK FOOTER //
// ./src/helpers/date.ts